/**
 * Copyright 2021 The AMP HTML Authors. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS-IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import {isFortesting} from './for-testing';
import {isTest} from './test';

/**
 * Returns true if executing in a local development or testing environment.
 * Calls may be DCE'd when compiled based on isFortesting and isTest.
 * @param {!Window=} opt_win
 * @return {boolean}
 */
export function isLocalDev(opt_win) {
  return isFortesting() && (!!self.AMP_CONFIG?.localDev || isTest(opt_win));
}
